module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }), _c('span', {
    attrs: {
      "href": "#/OEBPS/toc#intro",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_vm._v("Ever since May 2011, when the news first hit that there was a highly trained Belgian Malinois dog named Cairo who assisted a team of elite Navy SEALs in the raid that located and subsequently killed Osama bin Laden, people from all over have clamored for more information about the lives of the Military Working Dogs who serve in all branches of the U.S. military.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Though there have been countless stories and video news reports that have appeared in the years since the raid, people still can’t get enough, whether it’s learning about the lives of MWDs—short for “Military Working Dogs”—in wartime or the details about their constant training routines or what happens to them after they retire. Why do people love to hear stories about our canine soldiers? In short, because they represent everything that is great about the U.S. military. First of all, they serve a unique and specific purpose that no two-legged soldier could ever fill:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“These dogs act as a first line of defense against enemy threats because they can smell things and go places that humans can’t,” said Tech. Sgt. Roseann "), _c('a', {
    attrs: {
      "id": "page3"
    }
  }), _vm._v("Kelly, assistant flight chief with the 366th Security Forces Squadron at Mountain Home Air Force Base in Idaho.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page2"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "OEBPS/images/2-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Plus, their mere presence can have a huge effect even if they never bark or growl. “They’re a force multiplier, they give more power than just people alone,” said S.Sgt. Samuel Giordano, a handler at RAF Mildenhall in the United Kingdom. “The dogs are a huge psychological deterrent; people are often scared of them, and we use them for our own protection as well as force and resource protection.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Indeed, MWDs are often regarded as the last resort before a soldier decides to use deadly force. “When you fire a weapon, you can’t take that bullet back,” said Cpl. Ryan Pilz, a handler based at Marine Corps Base at Camp Lejeune, North Carolina. “These dogs are like our retractable bullets. A dog may chase after an enemy and attack him, but if the enemy surrenders or backs down, the dog can be called back.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But even though a canine soldier naturally serves as an effective weapon and crime deterrent, he needs a highly trained two-legged soldier to guide him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A dog team is a special kind of asset,” said Lance Cpl. Pete Hernandez, a handler with the 3rd Marine Expeditionary Force based in Okinawa, Japan. “It relies on one handler building a bond with his partner. [Together] … they can pinpoint where an odor is, tell explosive ordnance disposal Marines where to search, and if that’s not available we can choose an alternate route and not have to put [Marines] in danger. I would definitely say that I put my life in my dog’s hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the dog has the nose, the handler is responsible for interpreting and serving as translator for other humans; as such, most handlers would add Canine Mind Reading to the long list of skills that are necessary to serve as the human side of an effective MWD team. “You have to be able to read the dog’s change in behavior and be able to control them,” said S.Sgt. Randy Cottner, a military police dog handler. “I know he’s going to get sick before he gets sick.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“While there are soldiers throughout the ranks that only see military "), _c('a', {
    attrs: {
      "id": "page4"
    }
  }), _vm._v("working dogs as ‘dogs,’ you’d be hard-pressed to find a handler that feels this way,” said Sgt. 1st Class Aaron Meier, kennel master with the 550th Military Working Dog Detachment at Fort Bragg, North Carolina. “They become close, sometimes to an extent that it seems that they are one entity. In the end, a dog becomes an extension of the handler. Without one, the other is useless.”")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "OEBPS/images/4-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("However, to develop that seamless connection, it usually requires weeks or months of long hours of training together and just hanging out. While some dogs and handlers instantly bond from the first moment of meeting, the reality is usually something different, and so the job of handler is not for the impatient.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It took three to six months to develop the type of bond I wanted with Kiara,” said S.Sgt. Rosanne Caballero, an MWD trainer with the 799th Security Forces Squadron at Creech Air Force Base in Nevada. “I spent a lot of "), _c('a', {
    attrs: {
      "id": "page5"
    }
  }), _vm._v("time with her, got to know her, and she was with me everywhere I went while on duty. There’s more to this job [than people see] and it’s very time consuming. You have to want it. If your heart isn’t set in it, then this job isn’t for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As with any relationship that depends on being so closely attuned to your partner, trust is absolutely essential.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If the dog cannot trust you or you cannot trust the dog, there cannot be a rapport established and you will never become a team,” said S.Sgt. Nicholas Drake, an MWD trainer with the 354th Security Forces Squadron at Eielson Air Force Base in Alaska. “You will make mistakes and you have to be willing to let the dog make mistakes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And the primary way they accomplish this trust is by letting a dog do dog things: walking around the base, jumping through the hoops and climbing ladders on the obstacle course, and chasing a ball or tugging on a rope for hours.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both dog and human are obviously having a blast. But toss and fetch and the other games are actually bringing them together, to form a bond that will eventually help both to protect their fellow soldiers as well as each other when called upon to search for explosives and/or bad guys both at home and overseas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It looks like play time for the dog and in a sense it is,” said Tech. Sgt. Matthew Mosher, a handler who is also based out of Eielson Air Force Base. “Everything needs to be fun for the dog … and positive.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Once an MWD team achieves that bond, well, it’s hard to know where one begins and the other one starts; most MWDs are essentially a well-oiled machine where words are often not necessary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When you achieve that level of rapport there is nothing that dog won’t do for you,” said Mosher. “And once it’s achieved, it’s unbreakable.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the same time, just like their human counterparts, canine soldiers each have their own distinctive personalities, and they can act differently with different people.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page6"
    }
  }), _vm._v("“Imagine your M-4 [rifle], and now imagine your M-4 can communicate with you, and has good and bad days and a personality,” said Capt. Jake Porter, the provost marshal at Forward Operating Base Spin Boldak in Afghanistan. “That’s what handlers have to be able to deal with.”")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "OEBPS/images/6-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the years since my book "), _c('em', [_vm._v("The Dogs of War: The Courage, Love, and Loyalty of Military Working Dogs")]), _vm._v(" was published in the fall of 2011, it’s clear that readers love to read about these incredible four-legged soldiers. Indeed, interspersed between the chapters where I covered training, equipment, and life on the front lines some of the most popular parts of "), _c('em', [_vm._v("Dogs of War were")]), _vm._v(" the individual profiles of the MWDs scattered throughout the book in sidebars: the story of Rex, an MWD who served in Vietnam who received two gold crowns from a regular dentist and was able to return to serve by his partner’s side, and a German "), _c('a', {
    attrs: {
      "id": "page7"
    }
  }), _vm._v("shepherd named Bodo, who saved his handler’s life in Iraq by pulling him out of the line of gunfire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to the heartwarming stories of these canine soldiers in "), _c('em', [_vm._v("The Dogs of War,")]), _vm._v(" readers also marveled at the amazing photos that showed the dogs lunging through the air, jumping out of perfectly good helicopters, and always, "), _c('em', [_vm._v("always")]), _vm._v(" displaying the devotion they feel for their human partners. The public affairs departments that are a crucial part of any military base at home and overseas love to do stories about the canine soldiers in their employ, and it definitely shows. From the photos of MWDs wearing goggles—aka Doggies—and booties to pictures showing them being hoisted out of helicopters and even jumping out of planes, it’s these pictures that accurately and poignantly help capture the lives of these heroic dogs.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "OEBPS/images/7-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But there’s a softer side, too, whether it’s a picture of the Belgian Malinois "), _c('a', {
    attrs: {
      "id": "page8"
    }
  }), _vm._v("puppies who are specially bred and trained to serve and protect two-legged soldiers or one of the unguarded moments that shows a handler giving his canine partner the last drops of water from a canteen on a 120-degrees-in-the-shade day in a desert encampment; these photographs serve to reveal a little more about these incredible partnerships.")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "OEBPS/images/8-1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so "), _c('em', [_vm._v("Dogs Who Serve")]), _vm._v(" is devoted to telling the great stories of MWDs and their handlers along with featuring amazing photos that show them both at work and play. I hope that these stories and photos will help readers to appreciate and learn a little bit more about the absolute love and devotion that these dogs show towards their jobs and human partners and that they serve their country without question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the end, while life as a handler and MWD team certainly isn’t easy, the rewards are plentiful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }), _vm._v("“It’s great to come in to work and see your best friend every day,” said Sgt. Joseph Nault, an MWD trainer at Creech Air Force Base in Nevada. “It doesn’t matter if you’re not having a good day; [the dogs are] … going to get you going.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There is no better job in the Air Force. I put on my uniform and play with a dog,” said S.Sgt. Christopher Michaud, Nault’s co-worker at the 799th SFS and kennel master at the base. “What other job is like that where you get to go to work every day and get paid to play with dogs all day?”")]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _c('img', {
    attrs: {
      "alt": "Image",
      "src": "OEBPS/images/10-1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "OEBPS/images/10-2.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35025d05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/intro.vue
// module id = 72
// module chunks = 0